import { useNavigate } from "react-router-dom";
import ReactHtmlParser from "react-html-parser";
import IconSosmed from "./iconSosmed";
import * as PageRoutes from "../../utils/route_pages";
import ApiUtils from "../../utils/api_utils";
import { readMore } from "../../utils/utilities";

const Category = (props) => {
  const navigate = useNavigate();
  const { data } = props;

  return (
    <>
      {data ? (
        <div
          onClick={() =>
            navigate(`${PageRoutes.detailNews}/${data.id}/?isNews=true`)
          }
          className="d-flex align-items-center mb-4"
        >
          <div
            className="mr-1"
            style={{
              backgroundSize: "cover",
              height: 106,
              width: 106,
              backgroundPosition: "center",
              border: "1px solid #cecece",
              borderRadius: 10,
              backgroundImage: `url(${ApiUtils.validateImgUrl({
                url: data?.images?.img?.display,
              })}`,
            }}
          ></div>
          <div>
            <div className="mb-2 fs-14 text-black-400">{data.title}</div>
            <div className="text-black-400 fs-12 mb-3">
              {ReactHtmlParser(readMore(data.description))}
            </div>
            <div className="mb-2">
              <IconSosmed
                data={{
                  totalLike: data.total_like,
                  totalComment: data.total_comment,
                  totalViews: data.total_views,
                }}
              />
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
    </>
  );
};

export default Category;
